import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/filter-blue.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "Trayek Utama", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, "Tambah Trayek", -1)
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "w-full md:w-1/3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "Filter", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "pb-4 mb-4 border-bottom-grey-2 text-base font-extrabold" }, "Filter Option", -1)
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold" }, "Kelas", -1)
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold" }, "Tol/Non Tol", -1)
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "tol",
  class: "ml-2"
}, "Tol", -1)
const _hoisted_21 = { class: "w-1/2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "nontol",
  class: "ml-2"
}, "Non Tol", -1)
const _hoisted_23 = { class: "flex items-center justify-end gap-4" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Apply")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_DataEmpty = _resolveComponent("DataEmpty")!
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_DataEmptySearch = _resolveComponent("DataEmptySearch")!
  const _component_TrayekList = _resolveComponent("TrayekList")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SelectAsync = _resolveComponent("SelectAsync")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              class: "mb-2 sm:mb-0 flex gap-4",
              onClick: _ctx.showForm
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _ctx.icon.svg.plusEva
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        (!_ctx.isAnyTrayek && !_ctx.isSearch)
          ? (_openBlock(), _createBlock(_component_DataEmpty, {
              key: 0,
              onShowForm: _ctx.showForm
            }, null, 8, ["onShowForm"]))
          : (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              class: "card-no-shadow wrap-hjp-data-list"
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_InputIconRight, {
                      class: "input-search-header-custom",
                      placeholder: "Cari Trayek",
                      modelValue: _ctx.inputSearch,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputSearch) = $event)),
                      canClick: true,
                      icon: _ctx.icon.svg.searchEva,
                      onSubmitInput: _ctx.onSearch,
                      onKeyup: _withKeys(_ctx.onSearch, ["enter"])
                    }, null, 8, ["modelValue", "icon", "onSubmitInput", "onKeyup"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "flex items-center gap-4 background-grey-lighten-5 rounded-lg px-3 py-2 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openOverlayPanel($event)))
                    }, _hoisted_10)
                  ])
                ])
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  (!_ctx.isAnyTrayek && _ctx.isSearch)
                    ? (_openBlock(), _createBlock(_component_DataEmptySearch, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_TrayekList, {
                        key: 1,
                        trayekType: 'reguler',
                        path: _ctx.path,
                        onCountTrayek: _ctx.countTrayek
                      }, null, 8, ["path", "onCountTrayek"]))
                ])
              ]),
              _: 1
            })),
        _createVNode(_component_OverlayPanel, { ref: "refOverlayAction" }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createVNode(_component_SelectAsync, {
                    endpoint: "/management/v1/MsClass",
                    searchCustom: [['activeOnly', '=', 'true']],
                    fieldLabel: (v) => v.Name,
                    searchFields: ['name'],
                    placeholder: 'Semua Kelas',
                    modelValue: _ctx.selectedClass,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedClass) = $event))
                  }, null, 8, ["fieldLabel", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_RadioButton, {
                      inputId: "tol",
                      modelValue: _ctx.isTolFilter,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isTolFilter) = $event)),
                      value: "1"
                    }, null, 8, ["modelValue"]),
                    _hoisted_20
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_RadioButton, {
                      inputId: "nontol",
                      modelValue: _ctx.isTolFilter,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isTolFilter) = $event)),
                      value: "0"
                    }, null, 8, ["modelValue"]),
                    _hoisted_22
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Button, {
                class: "btn-back mr-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ( _ctx.resetFilter() ))
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "btn-primary mr-1",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.applyFilter($event)))
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}